<template>
  <div>
    <el-form label-width="80px" class="">
      <el-row>
        <el-col :span="6">
          <el-form-item label="编码" prop="">
            <el-input v-model="query.lebccode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="名称" prop="">
            <el-input v-model="query.lebcname"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="分类" prop="">
            <el-select v-model="query.lebcletid" :clearable="true" >
              <el-option v-for="(item, index) in letList" :label="item.letname" :value="item.letid" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-button icon="search" @click="getPageList">查询</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <vggrid ref="xTable" :list="list" tableheight="400" flexname="" :cols="cols" :showfooter="false"
            :showPage="true" :resizable="true"
            :total="query.total" @cellClick="cellClick" @pagechange="pagechange">
    </vggrid>
    <div>
      <el-button @click="sureDialog">确定</el-button>
      <el-button @click="closeDialog">关闭</el-button>
    </div>
  </div>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'lebcquery',
    props:{
      multiLine: false
    },
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        letList: [],
        cols: [
          { type:  'selection',fieldtype: 'C', title: '选择', calculExpr:'',width: 80 },
          { field: 'lebccode', fieldtype: 'C', title: '编码',calculExpr:'', addNewRowFlg: false},
          { field: 'lebcname', fieldtype: 'C', title: '名称',calculExpr:'',addNewRowFlg: false},
          { field: 'lebcmodel', fieldtype: 'C', title: '型号',calculExpr:'',addNewRowFlg: false},
          { field: 'lebcsize', fieldtype: 'C', title: '规格',calculExpr:'',addNewRowFlg: false},
          { field: 'lebcbarcode', fieldtype: 'C', title: '条形码',calculExpr:'',addNewRowFlg: false},
          { field: 'letname', fieldtype: 'C', title: '分类名',calculExpr:'',addNewRowFlg: false},
          { field: 'unitname', fieldtype: 'C', title: '计量单位',calculExpr:'',addNewRowFlg: false},
          { field: 'lebcpprice', fieldtype: 'F', title: '采购价格',calculExpr:'',addNewRowFlg: false},
          { field: 'lebcsprice', fieldtype: 'F', title: '销售价格',calculExpr:'',addNewRowFlg: false},
          { field: 'lebcinvaliddesc', fieldtype: 'C',title: '作废',calculExpr:'',addNewRowFlg: false},
          { field: 'lebcremark', fieldtype: 'C',title: '备注',calculExpr:'',addNewRowFlg: false}
        ],
        lebc: {},
        query: {
          total: 0,
          currPage: 1,
          pageSize: 20
        }
      }
    },
    created () {
      this.getLetList()
      this.getPageList()
    },
    mounted () {
    },
    watch: {
      async '$route' () {
        this.getPageList()
      }
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      async getLetList () {
        this.letList = await request({
          method: 'get',
          url: '/basic/let/getLetEndList',
          params: {comid: this.$store.getters.loginUser.usercomid}
        })
      },
      async closeDialog() {
        this.$emit('closeDialog')
      },
      async sureDialog() {
        this.$emit('sureDialog', this.$refs.xTable.$refs.xTable.getSelectRecords())
      },
      async cellClick (row) {
        this.lebc = row.row
      },
      async pagechange (lebcPage) {
        this.query.currPage = lebcPage.currentPage
        this.query.pageSize = lebcPage.pageSize
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/basic/lebc/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
